import { createFileRoute } from "@tanstack/react-router";
import { TenantSystemStatus } from "@client/components/tenant-settings/system-status/tenant-system-status";

export const Route = createFileRoute("/_app/tenant-settings/system-status")({
  component: TenantSystemStatus,
});
